import {
  DocumentOrganizationKeys,
  FilterDocument,
} from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export const defaultFilter: FilterDocument = {
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.CompletedDate,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  showCompleted: true,
};
